export default __webpack_public_path__ + "static/media/hht1_ep17_timeline_q03_a.4e2a8784.png";